export default __webpack_public_path__ + "static/create-insights-dark-4dc874ab776c52fb7983d4d6e3f05bac.png";